module.exports = __webpack_public_path__ + "static/media/tick.0e841d88.png";